const round = (value: number, precision: number): number => {
  const multiplicator = Math.pow(10, precision);
  return Math.round(value * multiplicator) / multiplicator;
};

export { round };
